"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseModel_1 = require("../BaseModel");
var PubliqKeyPair = /** @class */ (function (_super) {
    __extends(PubliqKeyPair, _super);
    function PubliqKeyPair(data) {
        var _this = _super.call(this) || this;
        if (data !== undefined) {
            _this.masterKey = data.master_key === undefined ? data.masterKey : data.master_key;
            _this.index = data.index;
            _this.publicKey = data.public_key === undefined ? data.publicKey : data.public_key;
            _this.privateKey = data.private_key === undefined ? data.privateKey : data.private_key;
        }
        return _this;
    }
    Object.defineProperty(PubliqKeyPair, "PropertyMap", {
        get: function () {
            return {
                masterKey: 'master_key',
                index: 'index',
                publicKey: 'public_key',
                privateKey: 'private_key',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PubliqKeyPair, "Rtt", {
        get: function () {
            return 49;
        },
        enumerable: true,
        configurable: true
    });
    return PubliqKeyPair;
}(BaseModel_1.default));
exports.default = PubliqKeyPair;



//////////////////
// WEBPACK FOOTER
// ./node_modules/blockchain-models-ts/bin/models/PubliqKeyPair.js
// module id = 153
// module chunks = 0 1